(function(angular, underscore, JSON){
    'use strict';

    angular.module('onvio.setup.appearance').controller('ThemeSetupController', themeSetup);
    themeSetup.$inject = [
        '$window',
        '$rootScope',
        '$scope',
        '$q',
        '$translate',
        '$timeout',
        'AuthenticatedSessionData',
        'ThemeSetupManager',
        'bluemoon.components.Notifications'
    ];

    function themeSetup($window, $rootScope, $scope, $q, $translate, $timeout, AuthenticatedSessionData, ThemeSetupManager, Notifications){

        /*jshint validthis:true */
        this.$onInit = function() {
            var vm = this;
            var themeViewData;
            var colorSchemeLength;
            var uploadConfig;

            vm.setSelectedColorScheme = setSelectedColorScheme;
            vm.saveTheme = saveTheme;
            vm.previewTheme = previewTheme;
            vm.resetTheme = resetTheme;
            vm.themeSettings = vm.themeSetupData;
            vm.headerTextChange = headerTextChange;
            vm.headerImageChange = headerImageChange;

            // Create method publicly available through 2-way data bound object
            vm.themeSettings.setThemeDirty = function(){
                vm.themeSettings.hasUnsavedTheme = vm.themeSetupForm.$dirty;
            };

            // theme setup URL with image template for ng-include
            vm.imageTemplatePreview = 'setup/src/themes/theme-setup-image-preview.html';

            vm.toggleSettings = {
                none: 'none',
                image: 'image',
                text: 'text'
            };

            // provide a shared api with the upload controller for sharing open function
            vm.imageUploadApi = vm.imageUploadApi || {};

            initializeView();

            function initializeView(){
                resetNotifications();

                if(angular.isUndefined(vm.themeSettings)){
                    $translate('Onvio.Setup.Theme.Load.Error').then(function(value){
                        Notifications.setInfo(value);
                    });

                    return;
                }

                themeViewData = getThemeSettings(vm.themeSettings.defaultThemeData, vm.themeSettings.firmSettings);
                setInitialDisplayFromTheme(themeViewData);
            }

            function getThemeSettings(defaultThemeData, firmSettings){
                // initialize with defaults
                var themeData = {
                    imagePreview: vm.toggleSettings.none,
                    textPreview: vm.toggleSettings.none
                };

                // Set default values
                themeData.cannedThemes = defaultThemeData.colorSchemes;
                themeData.defaultHeaderText = defaultThemeData.defaultHeaderText;
                themeData.pickerChooseText = $translate.instant('Onvio.Setup.Theme.Labels.ColorPickerChoose');
                themeData.pickerCancelText = $translate.instant('Onvio.Setup.Theme.Labels.ColorPickerCancel');
                themeData.selectedColorSheme = themeData.cannedThemes[0];
                colorSchemeLength = themeData.cannedThemes.length;

                // Override defaults with saved theme settings
                if(angular.isDefined(firmSettings)){
                    // Add in saved color theme to cannedTheme list for color picker options
                    var firmColor = ThemeSetupManager.getFormattedColorScheme(themeData.cannedThemes.length + 1, firmSettings.colors);

                    // Set firm colors as selected scheme
                    if(angular.isDefined(firmColor)){
                        // Note: This is a bit of overkill to provide a unique list of color schemes. There may be a better way.
                        var firmColors = [];
                        firmColors.push(firmColor);
                        themeData.cannedThemes = firmColors.concat(themeData.cannedThemes);
                        themeData.cannedThemes = underscore.uniq(themeData.cannedThemes, function(color){
                            return JSON.stringify(color.headerFill) +
                                JSON.stringify(color.headerText) +
                                JSON.stringify(color.buttonFill) +
                                JSON.stringify(color.buttonText);
                        });
                        colorSchemeLength = themeData.cannedThemes.length;
                        themeData.selectedColorSheme = firmColor;
                    }

                    // Has a theme ever been setup?
                    if(angular.isDefined(firmSettings.id) && firmSettings.id !== '')
                    {
                        // Setup the header image and text
                        if(angular.isDefined(firmSettings.headerImage)){
                            themeData.imagePreview = vm.toggleSettings.image;

                            // Comes in as a url so add cache busting
                            var cacheBuster = '&rand=' + $window.Math.floor($window.Math.random() * (10000 - 0 + 1)) + 0;
                            themeData.imageSrc = firmSettings.headerImage.indexOf('http')  >= 0 ? firmSettings.headerImage + cacheBuster : firmSettings.headerImage;
                        }

                        if(angular.isDefined(firmSettings.headerLine1)){
                            themeData.textPreview = vm.toggleSettings.text;
                            themeData.selectedHeaderText = {
                                lineOne: firmSettings.headerLine1
                            };
                        }
                    } else { // no firm settings ever setup, use default header text
                        themeData.textPreview = vm.toggleSettings.text;
                        themeData.selectedHeaderText = {
                            lineOne: themeData.defaultHeaderText.lineOne
                        };
                    }
                } else { // no firm settings, use default header text
                    themeData.textPreview = vm.toggleSettings.text;
                    themeData.selectedHeaderText = {
                        lineOne: themeData.defaultHeaderText.lineOne
                    };
                }

                return themeData;
            }

            function setInitialDisplayFromTheme(theme){
                vm.pickerChooseText = theme.pickerChooseText;
                vm.pickerCancelText = theme.pickerCancelText;
                setColorViewOptions(theme.cannedThemes, theme.selectedColorSheme);
                setHeaderImageViewOptions(theme.imagePreview, theme.imageSrc);
                setHeaderTextViewOptions(theme.textPreview, theme.selectedHeaderText);
            }

            function setColorViewOptions(colorSchemes, selectedScheme){
                vm.cannedThemes = colorSchemes;
                vm.pickerOptions = getColorPickerOptions(vm.cannedThemes);
                setSelectedColorScheme(selectedScheme, false);
            }

            function setSelectedColorScheme(scheme, isFormChange){
                vm.selectedColorScheme = scheme;
                vm.selectedTheme = angular.copy(scheme);

                if(isFormChange === true){
                    setFormDirty();
                }
            }

            function setHeaderImageViewOptions(imagePreview, imageSrc){
                vm.imagePreview = imagePreview;
                vm.imageSrc = imageSrc;
                setHeaderPreviewImage();
            }

            function setHeaderTextViewOptions(textPreview, selectedHeaderText){
                vm.textPreview = textPreview;
                vm.selectedHeaderText = angular.copy(selectedHeaderText);
            }

            ////////////

            function setHeaderPreviewImage(){
                vm.selectedImageSrc = vm.imageSrc;
            }

            function headerImageChange(){
                // clear any selected image if 'add image' unchecked
                if(vm.imagePreview === vm.toggleSettings.none){
                    vm.selectedImageSrc = undefined;
                    vm.imageSrc = undefined;
                    return;
                }

                if(angular.isUndefined(uploadConfig)){
                    initUploadConfig();
                }

                vm.imageUploadApi.openImageUploadModal(uploadConfig);
            }

            function initUploadConfig(){
                // setup config with callback to handle image selection
                // don't display delete image option

                uploadConfig = {
                    imageUploadCallback: headerImageUploadCallback,
                    deletable: false,
                    cropShape: 'rectangle'
                };
                // pick up translated strings specific to this file upload selector
                var promises = [
                    $translate('onvio.setup.theme.upload.title'),
                    $translate('onvio.setup.theme.upload.setHeaderImage')
                ];

                $q.all(promises).then(function(values) {
                    uploadConfig.uploadTitleText = values[0];
                    uploadConfig.saveImageButtonText = values[1];
                });
            }

            function headerImageUploadCallback(image){
                setFormDirty();
                vm.imageSrc = image;
                setHeaderPreviewImage();

                // reset add image toggle if an image was not selected
                if(angular.isUndefined(image) || image === ''){
                    vm.imagePreview = vm.toggleSettings.none;
                }
            }

            ////////////

            function setDefaultHeaderText(){
                vm.selectedHeaderText = angular.copy(themeViewData.defaultHeaderText);
            }

            function headerTextChange(){
                // clear any text from the header and reset to default when removed
                if(vm.textPreview === vm.toggleSettings.none){
                    if(angular.isDefined(vm.selectedHeaderText)){
                        vm.selectedHeaderText.lineOne = '';
                    }

                    return;
                }

                // set to default text if toggled on
                setDefaultHeaderText();
                focusElement('line1');
            }

            ////////////

            function saveTheme(){
                var theme = getThemeFromUserEntry();

                $scope.$emit('bm-busy-loading-on');

                var companyId = AuthenticatedSessionData.bindings.ApplicationConfiguration.CompanyId;
                resetNotifications();

                return ThemeSetupManager.saveTheme(companyId, theme).then(function(){
                    $scope.$emit('bm-busy-loading-off');

                    $rootScope.$emit('scollViewTop');
                    vm.themeSetupForm.$setPristine();
                    persistFirmSettings(theme);
                    themeViewData = getThemeSettings(vm.themeSettings.defaultThemeData, vm.themeSettings.firmSettings);
                    vm.themeSettings.hasUnsavedTheme = false;

                    $translate('Onvio.Setup.Theme.Success').then(function(value){
                        Notifications.setInfo(value);
                    });
                }, function(){
                    $scope.$emit('bm-busy-loading-off');
                    $translate('Onvio.Setup.Theme.Error').then(function(value){
                        Notifications.setError(value);
                    });
                });
            }

            function previewTheme(){
                var theme = getThemeFromUserEntry();
                $window.sessionStorage.setItem('onvio-staff-preview', JSON.stringify(theme));
                $window.open('appearance-preview.html');
            }

            function getThemeFromUserEntry(){
                var theme = {};

                // Make sure to keep theme id if making edits
                if(angular.isDefined(vm.themeSettings.firmSettings)){
                    if(angular.isDefined(vm.themeSettings.firmSettings.id)){
                        theme.id = vm.themeSettings.firmSettings.id;
                    }

                    theme.loginBackground = vm.themeSettings.firmSettings.loginBackground;
                    theme.logoutUrl = vm.themeSettings.firmSettings.logoutUrl;
                }

                theme.colors = {
                    headerFillColor: vm.selectedTheme.headerFill['background-color'],
                    headerTextColor: vm.selectedTheme.headerText['background-color'],
                    buttonFillColor: vm.selectedTheme.buttonFill['background-color'],
                    buttonTextColor: vm.selectedTheme.buttonText['background-color']
                };

                if(vm.imagePreview === vm.toggleSettings.image && angular.isDefined(vm.selectedImageSrc)){
                    theme.headerImage = vm.selectedImageSrc;
                }

                if(vm.textPreview === vm.toggleSettings.text && angular.isDefined(vm.selectedHeaderText)){
                    if(angular.isDefined(vm.selectedHeaderText.lineOne)){
                        theme.headerLine1 = vm.selectedHeaderText.lineOne;
                    }
                }

                return theme;
            }

            function persistFirmSettings(theme){
                // update object on scope so values persisted across tabs
                vm.themeSettings.firmSettings.colors = theme.colors;
                vm.themeSettings.firmSettings.headerImage = theme.headerImage;
                vm.themeSettings.firmSettings.headerLine1 = theme.headerLine1;
            }

            function resetNotifications(){
                Notifications.setError(null);
                Notifications.setInfo(null);
            }

            function resetTheme(){
                resetNotifications();
                vm.themeSetupForm.$setPristine();
                $rootScope.$emit('scollViewTop');
                setInitialDisplayFromTheme(themeViewData);
                vm.themeSettings.hasUnsavedTheme = false;
            }

            function setFormDirty(){
                vm.themeSetupForm.$setDirty();
            }

            ////////////

            function focusElement(elementId){
                if(angular.isDefined(elementId) && elementId !== ''){
                    $timeout(function() {
                        angular.element('#' + elementId).focus();
                    }, 100);
                }
            }

            function getColorPickerOptions(colorThemes){
                var colorPickerPalette = getBaseColorPalette(colorThemes);

                return {
                    preferredFormat: 'hex',
                    showInput: true,
                    showPalette: true,
                    clickoutFiresChange: true,
                    appendTo: '#themeContainer',
                    cancelText: function(){
                        return vm.pickerCancelText;
                    },
                    chooseText: function(){
                        return vm.pickerChooseText;
                    },
                    change: function(color){
                        var theme;

                        setFormDirty();
                        theme = angular.copy(vm.selectedTheme);

                        if(vm.cannedThemes.length === colorSchemeLength){
                            vm.cannedThemes.push(theme);
                        }

                        var colorProperty = this.parentNode.id;
                        theme[colorProperty]['background-color'] = color.toHexString();
                        vm.cannedThemes[vm.cannedThemes.length - 1] = theme;
                    },
                    palette: colorPickerPalette
                };
            }

            function getBaseColorPalette(colorThemes){
                var palette = [];

                if(angular.isUndefined(colorThemes) || colorThemes.length === 0){
                    return palette;
                }

                var currentTheme = [];

                angular.forEach(colorThemes, function(theme){
                    currentTheme.push(theme.headerFill['background-color']);
                    currentTheme.push(theme.headerText['background-color']);
                    currentTheme.push(theme.buttonFill['background-color']);
                    currentTheme.push(theme.buttonText['background-color']);
                });

                // Get a unique list of colors
                var uniqueColors = underscore.uniq(currentTheme);

                // Divide colors into groups of 5
                for (var i = 0; i < uniqueColors.length; i+= 5) {
                    palette.push(uniqueColors.slice(i, i + 5));
                }
                return palette;
            }
        };
    }
})(window.angular, window._, window.JSON);
